import { includes, filter, find, path, propEq, sort } from 'ramda';

import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { readEndpoint } from 'redux-json-api';
import { createSelector } from 'reselect';

import RouteBlockageForm from './RouteBlockageForm'

import { readEndpointDedup } from '../../modules/reducers/api';
import { isAdmin } from '../../modules/selectors/permissions';

const selector = formValueSelector('routeBlockageForm');

// Selectors
const selectCompanies = state => path(['api', 'company', 'data'], state) || [];
const selectActiveCompanies = state => {
  let companies = path(['api', 'company', 'data'], state) || [];
  if (companies) {
    companies = filter(company => path(['attributes', 'deleted-at'], company) === null)(companies);
  }

  return companies;
}
const selectRailways = state => path(['api', 'railway', 'data'], state) || [];
const selectStops = state => path(['api', 'stop', 'data'], state) || [];
const selectSelectedRailwayId = state => selector(state, 'railway');

const getSortedActiveRailways = createSelector([selectRailways], railways => {
  const isActive = railway => {
    const active = path(['attributes', 'active'], railway);

    if (active === true) return true;
    else if (active === false) return false;
    else return true; // Fallback for undefined.
  };

  const activeRailways = filter(isActive)(railways);

  const sortRailways = (a, b) => {
    const aSorting = path(['attributes', 'sorting'], a);
    const bSorting = path(['attributes', 'sorting'], b);

    return aSorting - bSorting;
  };

  return sort(sortRailways)(activeRailways);
});

const getRelatedStops = createSelector(
  [selectRailways, selectStops, selectSelectedRailwayId],
  (railways, stops, railwayId) => {
    if (!railwayId) return [];

    const railway = find(propEq('id', railwayId))(railways);
    if (!railway) return [];

    const relatedStops = path(['relationships', 'stops', 'data'], railway);
    if (!relatedStops) return [];

    const relatedStopIds = relatedStops.map(stop => stop.id);
    return filter(stop => includes(stop.id, relatedStopIds), stops);
  }
);

const mapStateToProps = (state) => ({
  companies: selectActiveCompanies(state),
  companiesAreInvited: selector(state, 'invite_non_preferred_companies'),
  isAdmin: isAdmin(state),
  railwayId: selectSelectedRailwayId(state),
  railways: getSortedActiveRailways(state),
  stops: getRelatedStops(state),
});

const mapDispatchToProps = {
  readEndpoint,
  readEndpointDedup,
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteBlockageForm);
